import React from 'react';
import PropTypes from 'prop-types';

import externalLinks from 'config/externalLinks';
import AnalyticsService from 'services/AnalyticsService';

const analytics = new AnalyticsService();

export const BaseLink = (props) => {
  const { analyticsMethod, children, newWindow, ...rest } = props;
  let target = {};

  if (newWindow) {
    target = { target: '_blank', rel: 'noopener noreferrer' };
  }

  return (
    <a {...rest} {...target}>
      {children}
    </a>
  );
};

BaseLink.propTypes = {
  analyticsMethod: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  newWindow: PropTypes.bool,
};

export const Twitter = (props) => {
  const onClick = () => analytics.outboundLinkTwitter();

  return (
    <BaseLink
      newWindow={true}
      {...props}
      href={externalLinks.social.twitter.url}
      onClick={onClick}
    >
      {externalLinks.social.twitter.label}
    </BaseLink>
  );
};

export const EmailHello = (props) => {
  const onClick = () => analytics.outboundLinkEmailHello();

  return (
    <BaseLink {...props} href={externalLinks.email.hello.url} onClick={onClick}>
      {externalLinks.email.hello.label}
    </BaseLink>
  );
};

export const HugggHome = (props) => {
  const onClick = () => analytics.outboundLinkHugggHome();

  return (
    <BaseLink
      newWindow={true}
      {...props}
      href={externalLinks.huggg.home.url}
      onClick={onClick}
    >
      {externalLinks.huggg.home.label}
    </BaseLink>
  );
};

export const HugggTerms = (props) => {
  const onClick = () => analytics.outboundLinkHugggTerms();

  return (
    <BaseLink
      newWindow={true}
      {...props}
      href={externalLinks.huggg.terms.url}
      onClick={onClick}
    >
      {externalLinks.huggg.terms.label}
    </BaseLink>
  );
};

export const HugggPrivacy = (props) => {
  const onClick = () => analytics.outboundLinkHugggPrivacy();

  return (
    <BaseLink
      newWindow={true}
      {...props}
      href={externalLinks.huggg.privacy.url}
      onClick={onClick}
    >
      {externalLinks.huggg.privacy.label}
    </BaseLink>
  );
};

export const HugggHelp = (props) => {
  const { isWelfare, ...rest } = props;

  const onClick = () => analytics.outboundLinkHugggHelp();

  const link = isWelfare
    ? externalLinks.huggg.b2gHelp
    : externalLinks.huggg.help;

  return (
    <BaseLink newWindow={true} {...rest} href={link.url} onClick={onClick}>
      {link.label}
    </BaseLink>
  );
};

HugggHelp.propTypes = {
  ...BaseLink.propTypes,
  isWelfare: PropTypes.bool,
};

export const HugggEmailSupport = (props) => {
  const onClick = () => analytics.outboundSupportEmail();

  return (
    <div style={{ display: 'block' }}>
      <span>Email us at&nbsp;</span>
      <BaseLink
        newWindow={true}
        {...props}
        href={externalLinks.email.support.url}
        onClick={onClick}
      >
        {externalLinks.email.support.label}
      </BaseLink>
    </div>
  );
};
